import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

export class CommunicationsRequestGetConferenceParticipantsSchema extends CommunicationsRequestSchema {
  public static readonly conferenceFriendlyName = 'conferenceFriendlyName';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[CommunicationsRequestGetConferenceParticipantsSchema.conferenceFriendlyName] =
      SchemaField.autoGeneratedDocId(undefined).required();

    return parameters;
  }
}
